import * as React from 'react'
//import { useEffect } from 'react'
import Head from 'next/head'
import { NextPage } from 'next'
//import { Query, QueryGetReviewsArgs } from '../generated/nest-graphql'
//import gql from 'graphql-tag'
import { getReviewIODataFromNest } from '../asyncLoaders/nest'
import { ReviewPageTopSection } from '../components/ReviewsPage/ReviewsPageTopSection'
//import { ReviewsList } from '../components/ReviewsPage/ReviewsList'
import withApolloHOC from '../components/withApolloHOC'
//import { useQuery } from '@apollo/react-hooks'
import { getDataFromTree } from '@apollo/react-ssr'
//import { mergeDeepRight } from 'ramda'
//import { debounce } from 'debounce'
import Layout from '../components/Layout'
import { FeatureBySection } from '../components/FeatureBySection'

/*const GET_REVIEWS_QUERY = gql`
  query getReviews($cursor: String, $limit: Int) {
    getReviews(cursor: $cursor, limit: $limit) {
      edges {
        reviewerName
        reviewType
        rating
        comment
        branch
        dateCreated
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`*/

export const ReviewsPage: NextPage<{ reviewCount: number; rating: string }> = (props) => {
  const { reviewCount, rating } = props
  /*const query = useQuery<Query, QueryGetReviewsArgs>(GET_REVIEWS_QUERY, {
    variables: {
      limit: 50,
    },
  })

  const loadMore = debounce(async () => {
    if (query && query.data && query.data.getReviews.pageInfo.hasNextPage) {
      await query.fetchMore({
        query: GET_REVIEWS_QUERY,
        variables: {
          cursor: query.data.getReviews.pageInfo.endCursor,
          limit: 50,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const updates = {
            getReviews: {
              edges: [...prev.getReviews.edges, ...fetchMoreResult.getReviews.edges],
              pageInfo: fetchMoreResult.getReviews.pageInfo,
            },
          }
          return fetchMoreResult.getReviews.edges.length ? mergeDeepRight(prev, updates) : prev
        },
      })
    }
    return null
  })*/

  /*const listener = async (e) => {
    const scrollY = window.scrollY
    const topOffset = e.target.getElementsByTagName('footer')[0].offsetTop
    if (topOffset - scrollY < 2000) {
      //await loadMore()
    }*/
  /*useEffect(() => {
    window.addEventListener('scroll', listener)
    return () => window.removeEventListener('scroll', listener)
  })*/
  return (
    <Layout title={'Reviews - NuBrakes Mobile Brake Repair'}>
      <Head>
        <meta
          name="description"
          content={`Find out why people love and trust using NuBrakes for affordable, convenient brake repairs delivered right where you’re parked at home or work!`}
        />
      </Head>
      <ReviewPageTopSection
        title={'Trusted by Drivers Like You'}
        description={`NuBrakes is rated ${rating}/5 by ${reviewCount.toLocaleString('en-US')} brake repair customers`}
      />
      <FeatureBySection />
      <div className='p-1 w-screen'>
        {/* Script Tag - use dangerouslySetInnerHTML */}
        <div
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{
          __html: `<script src="https://storyprompt.com/js/iframeResizer.min.js"></script>`,
        }}
      />
      <iframe 
       loading="eager" 
       id="SP_5LvBBKBNirflE8PipN7F" 
       src="https://storyprompt.com/wall/5LvBBKBNirflE8PipN7F" 
       frameBorder="0" 
       width="100%"
       height="800px"
       //style={{ height: '100vh;' }}
       ></iframe> 
      <div
      style={{ display: 'none' }}
        dangerouslySetInnerHTML={{
          __html: `<script>iFrameResize({checkOrigin: false, heightCalculationMethod: "taggedElement"}, '#SP_5LvBBKBNirflE8PipN7F');</script>`,
        }}
      />
      </div>
      {/*query.data && <ReviewsList reviewConnection={query.data.getReviews} />*/}
    </Layout>
  )
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ReviewsPage.getInitialProps = async () => {
  const { reviewCount, rating } = await getReviewIODataFromNest()
  return {
    reviewCount,
    rating,
  }
}

export default withApolloHOC(ReviewsPage, { getDataFromTree })
